import { PRINT_FORM_CONFIGS } from '../config/printFormConfigs'
import { PrintFormConfig } from '../types'

let _store: PrintFormConfig[] = [...PRINT_FORM_CONFIGS]

export const mockPrintFormsStore = {
  getAll(): PrintFormConfig[] {
    return [..._store]
  },

  getById(id: string): PrintFormConfig | null {
    return _store.find(c => c.id === id) ?? null
  },

  create(config: PrintFormConfig): PrintFormConfig {
    _store.push(config)

    return config
  },

  update(config: PrintFormConfig): PrintFormConfig {
    _store = _store.map(c => (c.id === config.id ? config : c))

    return config
  },

  delete(id: string): void {
    _store = _store.filter(c => c.id !== id)
  },

  copy(id: string, newId: string, newTitle: string): PrintFormConfig | null {
    const original = _store.find(c => c.id === id)
    if (!original) return null
    const copied = { ...original, id: newId, title: newTitle }
    _store.push(copied)

    return copied
  },
}
